import { z } from 'zod';
import { IsoDate, MoneyAmount } from '../primitives.js';

/**
 * S13-BE.1 — Tax summary DTO (read-only, без persistence).
 * Агрегат для бухгалтера: НДС к уплате/зачёту, КПН-аванс, прочие налоги.
 */

export const TaxSummaryPeriod = z.object({
  date_from: IsoDate,
  date_to: IsoDate,
});
export type TaxSummaryPeriod = z.infer<typeof TaxSummaryPeriod>;

export const TaxSummary = z.object({
  period: TaxSummaryPeriod,
  vat_payable: MoneyAmount,
  vat_credit: MoneyAmount,
  vat_net: MoneyAmount,
  income_tax_advance: MoneyAmount,
  payroll_taxes_placeholder: MoneyAmount,
  schema_version: z.string(),
});
export type TaxSummary = z.infer<typeof TaxSummary>;
